export default __webpack_public_path__ + "static/vaszsgir2019-4b53fe20a26c1eeda799a0c323a169d9.png";